<template>
    <div class="form popup-form">
        <h3 class="popup-tilte">Ingatlan kiválasztása</h3>
        <label class="select-label d-table w-100 text-center" v-if="getRealEstates.length === 0">
            Még nincs rögzített ingatlanadat.
        </label>
        <label class="select-label d-table w-100 text-center" v-else>
            {{ getRealEstates.length > 1 ? 'Elérhető ingatlan adatok' : 'Elérhető ingatlan adatok:' }}
        </label>
        <div class="d-flex fs-bold justify-center mt-12px text-center flex-row" v-if="getRealEstates.length === 1"
             style="column-gap: 1rem;">
            {{ makeAddress(getRealEstates[0]) }}
            <button
                type="button"
                class="btn btn-blue m-auto mt-30px"
                @click="selectRealEstate"
                style="margin-left: 15px;width: 10rem;"
            >
                Betöltés
            </button>
        </div>
        <div class="w-100 d-flex flex-row" v-if="getRealEstates.length > 1" style="column-gap: 1rem;">
            <select name="real_estate" class="mw-500px d-table" v-model="selected">
                <option v-for="(real_estate, index) in getRealEstates" :key="index" :value="real_estate.id">
                    {{ makeAddress(real_estate) }}
                </option>
            </select>
            <button
                type="button"
                class="btn btn-blue m-auto mt-30px"
                @click="selectRealEstate"
                style="margin-left: 15px"
            >
                Betöltés
            </button>
        </div>
        <h3 class="popup-tilte" v-if="getBikaRealEstate.length > 0">Importálás Eurorisk központi adatbázisból:</h3>
        <span class="d-flex fs-bold justify-center mt-12px text-center" v-if="getBikaRealEstate.length === 1">
			{{ getBikaRealEstate[0].full_address }}
             <button
                 type="button"
                 class="btn btn-blue m-auto mt-30px"
                 @click="selectBikaRealEstate"
                 style="margin-left: 15px;width: 10rem;"
             >
                Betöltés
            </button>
		</span>
        <div class="w-100 d-flex flex-row" v-if="getBikaRealEstate && getBikaRealEstate.length > 1"
             style="column-gap: 1rem;">
            <select name="bika_real_estate" class="mw-500px d-table" v-model="bikaSelected">
                <option v-for="(real_estate, index) in getBikaRealEstate" :key="index" :value="index">
                    {{ real_estate.full_address }}
                </option>
            </select>
            <button
                type="button"
                class="btn btn-blue m-auto mt-30px"
                @click="selectBikaRealEstate"
                style="margin-left: 15px;width: 10rem;"
            >
                Betöltés
            </button>
        </div>

        <div class="d-flex mt-4">
            <button
                type="button"
                :class="{ 'btn-blue': getRealEstates.length === 0, 'btn-blue-inverse': getRealEstates.length > 0 }"
                class="btn m-auto mt-30px"
                @click="selectNewRealEstate"
            >
                Új ingatlan
            </button>
        </div>
    </div>
</template>

<script>
import Select from '@/components/elements/Select';
import {mapActions, mapGetters, mapMutations} from 'vuex';

export default {
    mounted() {
        if (this.getRealEstates.length > 0) {
            this.selected = this.getRealEstates[0].id;
        }
    },
    components: {
        Select,
    },
    data() {
        return {
            selected: null,
            bikaSelected: 0,
        };
    },
    computed: {
        ...mapGetters(['getRealEstates', 'getBikaRealEstate']),
    },
    methods: {
        ...mapMutations(['showPopup', 'setRealEstateData', 'setOutbuildings','setLoadedAddress','setStateData']),
        ...mapActions(['setSelectedRealEstateData', 'clearSelectedRealEstateData']),
        selectRealEstate() {
            this.setSelectedRealEstateData(this.selected);
            this.$router.push({name: 'property-details'});
            this.showPopup(null);
        },
        selectNewRealEstate() {
            this.clearSelectedRealEstateData();
            this.$router.push({name: 'property-details'});
            this.showPopup(null);
        },
        makeAddress(realEstate) {
            let address = `${realEstate.postal_code} ${realEstate.city}, ${realEstate.address} `;

            if (realEstate.house_number !== null) {
                address = `${address} ${realEstate.house_number}.`;
            } else {
                address = `${address} | ${realEstate.parcel_number}`;
            }

            return address;
        },
        async selectBikaRealEstate() {
            this.setRealEstateData(this.getBikaRealEstate[this.bikaSelected].real_estate);
            this.setOutbuildings(this.getBikaRealEstate[this.bikaSelected].outbuildings);
            this.setLoadedAddress(this.getBikaRealEstate[this.bikaSelected].full_address);
            if(this.getBikaRealEstate[this.bikaSelected].real_estate.parcel_number !== null && this.getBikaRealEstate[this.bikaSelected].real_estate.house_number === null) {
                this.setStateData({ prop: 'hasParcelNumber', value: true });
            }
            await this.$router.push({name: 'property-details'});
            this.showPopup(null);
        },
    },
};
</script>

